import React, { useState } from "react";
import { Modal, Button } from "antd";
import { PaperClipOutlined } from '@ant-design/icons';
import { Localize, ModalStandard } from "components/service";
import Icons from "components/icons";
import StandForms from "../forms";
import { TStand } from "../helpers/stand-types-helper";
import { useMutation } from "@apollo/client";
import { STAND_TYPE_META_SET } from "graphql/mutation/stand-gql";


interface IStand3dModelFieldProps
{
    stand: TStand;
    standTypesGroup: TStand[] | undefined;
    disabled?: boolean;
}

const Stand3dModelField: React.FC<IStand3dModelFieldProps> = ({ stand, standTypesGroup, disabled = false }) =>
{
    const [ modalVisible, setModalVisible ] = useState(false);
    const [ iframeError, setIframeError ] = useState(false);

    const modelMeta = standTypesGroup
        ?.find((item) => item.lang === "de")
        ?.meta_fields
        ?.find((m) => m.meta_key === "additional_stand_type_fields_3d_model" && m.meta_group === "3d_models");
    const modelUrl = modelMeta?.meta_value || "";

    const [ set3dModel, { loading: loadingDelete } ] = useMutation(STAND_TYPE_META_SET, {
        onCompleted()
        {
            setModalVisible(false);
            setIframeError(false);
        },
    });

    const handleDelete = () =>
    {
        set3dModel({
            variables: {
                stand_type_id: stand?.group_id,
                input: [
                    {
                        id: modelMeta?.id,
                        action: "delete",
                        meta_key: "additional_stand_type_fields_3d_model",
                        meta_group: "3d_models",
                        meta_value: "",
                    },
                ],
            },
        });
    };


    return (
        <div className={`add-3d-model-field ${modelUrl && "link-upload"}`}>
            {modelUrl ? (
                <>
                    <ul className="link-list">
                        <li>
                            <PaperClipOutlined />
                            <span
                                className={`text-link ${disabled ? 'disabled' : ''}`}
                                onClick={disabled ? undefined : () => { setModalVisible(true); setIframeError(false); }}
                                style={{ opacity: disabled ? 0.5 : 1, cursor: disabled ? 'not-allowed' : 'pointer' }}
                            >
                                {modelUrl}
                            </span>
                            <Button icon={<Icons.Delete />} loading={loadingDelete} onClick={handleDelete} disabled={disabled} />
                        </li>
                    </ul>
                    <Modal
                        className="modal-3d-model"
                        width={800}
                        open={modalVisible}
                        onCancel={() => setModalVisible(false)}
                        closeIcon={<Icons.Close />}
                        footer={null}
                        centered
                    >
                        {iframeError ? (
                            <div style={{ textAlign: "center", padding: 40 }}>
                                <Localize>GLOBAL.Text_3DModelUnavailable</Localize>
                            </div>
                        ) : (
                            <iframe
                                src={modelUrl}
                                title="3D Model"
                                width="100%"
                                height="500"
                                style={{ border: 0 }}
                                onError={() => setIframeError(true)}
                                onLoad={() => setIframeError(false)}
                                allowFullScreen
                            />
                        )}
                    </Modal>
                </>
            ) : (
                <ModalStandard
                    width={400}
                    extraClass={"modal-form add-3d-model-modal-form"}
                    modalButton={
                        <div className={`modal-button ${disabled ? 'disabled' : ''}`} style={{ opacity: disabled ? 0.5 : 1, pointerEvents: disabled ? 'none' : 'auto' }}>
                            <Icons.Plus />
                            <span>
                                <Localize br={<br />}>GLOBAL.Button_Text_Add3DModel</Localize>
                            </span>
                        </div>
                    }
                    modalTitle={
                        <strong className="modal-title">
                            <span className="text">
                                <Localize>FORMS.Title_Add3DModel</Localize>
                            </span>
                        </strong>
                    }
                >
                    <StandForms.StandAdd3dModel
                        standTypeId={stand?.group_id}
                        initialUrl={modelUrl}
                        metaFieldId={modelMeta?.id}
                        action={() => { }}
                    />
                </ModalStandard>
            )}
        </div>
    );
};

export default Stand3dModelField;